document.addEventListener('DOMContentLoaded', () => {
    // Scroll Reveal Animation Observer
    const revealElements = document.querySelectorAll('.reveal-on-scroll');
    const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                // Optional: stop observing once revealed
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        threshold: 0.15, // Trigger when 15% of the element is visible
        rootMargin: "0px 0px -50px 0px" // Slight offset
    });

    revealElements.forEach(el => revealObserver.observe(el));

    // Dynamically build carousel if JSON data is provided
    const dataElement = document.getElementById('carousel-data');
    const container = document.querySelector('.carousel-container');
    if (dataElement && container) {
        try {
            const slidesData = JSON.parse(dataElement.textContent);
            if (slidesData && slidesData.length > 0) {
                let html = `
                    <div class="splide" id="preview-splide">
                        <div class="splide__track">
                            <ul class="splide__list">
                `;
                slidesData.forEach((slide, index) => {
                    const safeUrl = (slide.url || '').replace(/"/g, "&quot;").replace(/</g, "&lt;");
                    const safeAlt = (slide.alt || '').replace(/"/g, "&quot;").replace(/</g, "&lt;");
                    const safeCaption = (slide.caption || '').replace(/</g, "&lt;");
                    const fallbackSvg = encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' width='1200' height='675' viewBox='0 0 1200 675'><rect fill='#1a1a2e' width='1200' height='675'/><text fill='#ffffff' font-family='sans-serif' font-size='30' dy='10.5' font-weight='bold' x='50%' y='50%' text-anchor='middle'>Placeholder: Upload ${slide.url}</text></svg>`).replace(/'/g, "%27");

                    // Compute safe thumbnail URL by replacing extension
                    let safeThumbUrl = safeUrl;
                    const match = safeUrl.match(/(\.[\w\d_-]+)$/i);
                    if (match) {
                        safeThumbUrl = safeUrl.replace(match[1], '_thumb' + match[1]);
                    }

                    html += `
                                <li class="splide__slide">
                                    <div class="carousel-slide hover-glow hover-glow-amber" style="display: flex; flex-direction: column; border-radius: 12px; overflow: hidden; background: rgba(17, 17, 17, 0.6); border: 1px solid var(--glass-border); aspect-ratio: 1/1;">
                                        <a href="#preview-slide-${index}" data-fslightbox="gallery" style="display: flex; flex-direction: column; flex: 1; height: 100%; text-decoration: none;">
                                            <img src="${safeThumbUrl}" alt="${safeAlt}" onerror="this.src='${safeUrl}'; this.onerror=function(){this.src='data:image/svg+xml;charset=UTF-8,${fallbackSvg}'};" style="width: 100%; height: 100%; object-fit: cover; flex: 1; min-height: 0; display: block; background: rgba(0,0,0,0.3);">
                                            <div style="padding: 1rem; color: white; font-weight: 600; text-align: center; font-size: 1.1rem; background: rgba(0, 0, 0, 0.2); flex: 0 0 auto;">${safeCaption}</div>
                                        </a>
                                        
                                        <div style="display: none;">
                                            <div id="preview-slide-${index}" style="position: relative; max-width: 90vw; max-height: 90vh;">
                                                <img src="${safeUrl}" style="width: 100%; height: auto; max-height: 90vh; object-fit: contain;">
                                                <div style="position: absolute; bottom: 0; left: 0; width: 100%; padding: 1.5rem; background: linear-gradient(transparent, rgba(0,0,0,0.8)); color: white; text-align: center; font-weight: 600; font-size: 1.5rem;">${safeCaption}</div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                    `;
                });
                html += `
                            </ul>
                        </div>
                    </div>
                `;
                container.innerHTML = html;

                // Refresh fslightbox to attach to the dynamically generated links
                if (typeof refreshFsLightbox !== 'undefined') {
                    refreshFsLightbox();
                }

                // Initialize Splide
                new Splide('#preview-splide', {
                    type: 'loop',
                    autoplay: true,
                    interval: 10000,
                    pauseOnHover: true,
                    perPage: 3,
                    gap: '2rem',
                    pagination: true,
                    arrows: true,
                    drag: true,
                    speed: 300,
                    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
                    breakpoints: {
                        1024: { perPage: 2, gap: '1.5rem' },
                        768: {
                            perPage: 1,
                            gap: '1rem',
                            padding: { left: 0, right: '15%' }
                        }
                    }
                }).mount();
            }
        } catch (e) {
            console.error('Failed to parse carousel data', e);
        }
    }
});
